import { useAIAgentFi } from "@/components/apis/aiagentFi";
import Image from "@/components/Image";
import { Modal } from "@/components/Modals/Modal";
import { useMemo } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";

export const LIST_TOKEN = [
  { id: 0, image: "/token_aigenfi/token_1.png" },
  { id: 1, image: "/token_aigenfi/token_2.png" },
  { id: 2, image: "/token_aigenfi/token_3.png" },
  { id: 3, image: "/token_aigenfi/token_4.png" },
  { id: 4, image: "/token_aigenfi/token_5.png" },
  { id: 5, image: "/token_aigenfi/token_6.png" },
  { id: 6, image: "/token_aigenfi/token_7.png" },
  { id: 7, image: "/token_aigenfi/token_8.png" },
];

export function AiAgentModal(props: { onClose: () => void }) {
  const { data } = useAIAgentFi();

  const [image1, image2] = useMemo(() => {
    const list = (data?.data ?? []).map((e) => {
      return e.iconUrl;
    });

    const center = Math.ceil(list.length / 2);

    const res = [list.slice(0, center), list.slice(center + 1)];

    return res;
  }, [data?.data]);

  return (
    <Modal isOpen={true} position="right" onClose={() => props.onClose()}>
      <div className="flex flex-col gap-2 md:w-80 w-full px-2 py-5">
        <div className="flex flex-col gap-4 p-5 rounded-3xl bg-white">
          <div className="flex gap-4 items-center flex-col md:flex-row">
            <Image
              src={require("@/assets/images/menu/AiAgent.png")}
              alt="Ai AgentFi"
              className="w-20 h-20 md:w-12 md:h-12"
              width={400}
              height={400}
            />
            <p className="text-2xl font-medium text-black">A(i)gentFi</p>
          </div>

          <Link
            to={"https://aigentfi.com"}
            target="_blank"
            className="hidden md:flex items-center justify-center bg-black w-full rounded-[90px] px-8 py-4"
          >
            <span className="text-base text-white font-medium">Launch App</span>
          </Link>
        </div>

        <div className="p-5 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC]">
          <p className="text-2xl text-[#777E90] font-medium">
            Leverages multi-AI agents to enable seamless creation, tokenization,
            co-ownership, and collaboration
          </p>
        </div>

        <div className="flex flex-col gap-8 py-8 rounded-3xl bg-[#F4F5F6] md:bg-white border md:border-none border-solid border-[#E6E8EC]">
          <div className="flex flex-col gap-6">
            <Marquee className="flex items-center gap-6">
              <div className="overflow-hidden relative flex flex-nowrap gap-6">
                {image1.map((item, index) => (
                  <div
                    key={index.toString()}
                    className="flex-shrink-0 w-[88px] h-[88px] rounded-2xl overflow-hidden"
                  >
                    <Image
                      src={item}
                      alt={`Image ${index}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </Marquee>

            <Marquee direction="right" className="flex items-center gap-6">
              <div className="overflow-hidden relative flex flex-nowrap gap-6">
                {image2.map((item, index) => (
                  <div
                    key={index.toString()}
                    className="flex-shrink-0 w-[88px] h-[88px] rounded-2xl overflow-hidden"
                  >
                    <Image
                      src={item}
                      alt={`Image ${index}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </Marquee>
          </div>

          <div className="px-5">
            <p className="text-sm font-medium text-[#777E90]">Agent popular</p>
            <p className="mt-1 text-2xl text-black font-medium">
              Take Profit with Agent
            </p>
          </div>

          <button
            type="button"
            data-action="redirect_aigentfi"
            className="fixed md:hidden bottom-10 bg-black w-fit min-w-44 rounded-[90px] px-8 py-4 left-1/2 transform -translate-x-1/2 text-center"
            onClick={() => {
              window.open("https://aigentfi.com/", "_blank");
            }}
          >
            <p className="text-base text-white font-medium">Launch App</p>
          </button>
        </div>
      </div>
    </Modal>
  );
}
